import { ReactNode } from "react";
import { JSX } from "react";

import { baseTheme } from "@4pace-cpq/core";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";
import { Theme, ThemeProvider, createTheme } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { GatewayProvider } from "@plansoft-configuration-renderer/gateway";

import { EnvJSONProvider } from "./configurator/renderer/customContext/EnvContext";
import { AdministrationAreaProvider } from "./providers/administrationAreaProvider";
import { AppSettingsProvider } from "./providers/appSettingsProvider";
import { EasySessionProvider } from "./providers/easySessionProvider";
import { UiTranslationsProvider } from "./providers/uiTranslationsProvider";
import { theme as WEGTheme } from "./theme/theme";

const cacheNoPrefixer = createCache({
  //removes the vendor prefix on dev
  key: "noprefixer",
  ...(process.env.NODE_ENV === "development" && { stylisPlugins: [] }),
});
const theme = createTheme(deepmerge(baseTheme as Theme, WEGTheme));
let recaptchaKey = "6Ldb1i4sAAAAANd-Ymp3veV-1TmoELGpBZ90U9RG";
if (
  //window.location.origin.includes("stag.") ||
  window.location.origin.includes("dev.")
) {
  recaptchaKey = "6Lf0yxosAAAAAFS8HDUfcqnRj98xu5GaQcyT2Hg8";
}
export function Providers({ children }: { children: ReactNode }): JSX.Element {
  return (
    <GatewayProvider>
      <EnvJSONProvider>
        <CacheProvider value={cacheNoPrefixer}>
          <ThemeProvider theme={theme}>
            <GoogleReCaptchaProvider type="v3" siteKey={recaptchaKey}>
              <AdministrationAreaProvider>
                <EasySessionProvider>
                  <AppSettingsProvider>
                    <UiTranslationsProvider>{children}</UiTranslationsProvider>
                  </AppSettingsProvider>
                </EasySessionProvider>
              </AdministrationAreaProvider>
            </GoogleReCaptchaProvider>
          </ThemeProvider>
        </CacheProvider>
      </EnvJSONProvider>
    </GatewayProvider>
  );
}
